import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SortableContext, horizontalListSortingStrategy } from '@dnd-kit/sortable';
import DraggableHeaderCell from '../DraggableHeaderCell';

const TableHeader = ({ table, tableVisibleColsKey, tableHeight }) => {
  const sortableItems = React.useMemo(() => table.getVisibleLeafColumns().map(c => c.id), [tableVisibleColsKey]);

  return (
    <thead className="NewBaseTable__head">
      {table.getHeaderGroups().map(({ headers, id }) => (
        <tr className={classNames('NewBaseTable__row', 'NewBaseTable__head__row')} key={id}>
          <SortableContext items={sortableItems} strategy={horizontalListSortingStrategy}>
            {headers.map(header => (
              <DraggableHeaderCell key={header.id} header={header} tableHeight={tableHeight} />
            ))}
          </SortableContext>
        </tr>
      ))}
    </thead>
  );
};

TableHeader.propTypes = {
  table: PropTypes.object.isRequired,
  tableVisibleColsKey: PropTypes.string.isRequired,
  tableHeight: PropTypes.number.isRequired,
};

const MemoizedTableHeader = memo(
  TableHeader,
  (prev, next) =>
    prev.table.options.data === next.table.options.data &&
    prev.tableVisibleColsKey === next.tableVisibleColsKey &&
    prev.tableHeight === next.tableHeight
);

export default MemoizedTableHeader;
